/* eslint-disable import/prefer-default-export */

export const INSTRUCTIONS_PAGE = {
  NOTE_TEXT:
    'Please note all questions will appear in your default language. This language can be changed for a particular question later on.',
  TNC_TEXT:
    'I have read and understood the instructions. All computer hardware allotted to me is in proper working condition. I declare that I am not in possession of / not wearing / not carrying any prohibited gadget like mobile phone, bluetooth devices etc. /any prohibited material with me into the Examination Hall. I agree that in case of not adhering to the instructions, I shall be liable to be debarred from this Test and/or to disciplinary action, which may include a ban from future Tests / Examinations'
};

export const ATTEMPT_STATES = [
  {
    imageSrc: '/test-revamp/shape-1.png',
    alt: 'not-visited',
    text: 'You have not visited the question yet.'
  },
  {
    imageSrc: '/test-revamp/shape-2.png',
    alt: 'not-answered',
    text: 'You have not answered the question.'
  },
  {
    imageSrc: '/test-revamp/shape-3.png',
    alt: 'answered',
    text: 'You have answered the question.'
  },
  {
    imageSrc: '/test-revamp/shape-4.png',
    alt: 'marked',
    text: 'You have not answered the question, but have marked the question for review.'
  },
  {
    imageSrc: '/test-revamp/shape-5.png',
    alt: 'marked and answered',
    text: 'The question(s) ‘marked & answered’ will be considered for evalution.'
  }
];

export const GENERAL_INSTRUCTIONS = [
  {
    text: 'Total duration of the Quiz is _ mins.'
  },
  {
    text: 'The clock will be set at the server. The countdown timer in the top right corner of screen will display the remaining time available for you to complete the examination. When the timer reaches zero, the examination will end by itself. You will not be required to end or submit your examination.'
  },
  {
    text: 'The questions palette displayed on the right side of screen will show the status of each question using one of the following symbols:'
  },
  {
    text: 'You can click on the language dropdown on the top right corner of the question to change the language for that question.'
  }
];

export const QUESTION_NAV_INSTRUCTIONS = [
  {
    text: 'Click on the question number in the question palette at the right of your screen to go to that numbered question directly. Note that using this option does not save your answer to the current question.'
  },
  {
    text: 'Click on <span class="bold">Save & next</span> to save your answer for the current question and then go to the next question.'
  },
  {
    text: 'Click on <span class="bold">Mark for review</span> to mark a question for review.'
  }
];

export const ANSWERING_INSTRUCTIONS = [
  {
    text: 'Procedure for answering a multiple choice type question:',
    subInstructions: [
      {
        text: 'To select you answer, click on the button of one of the options.'
      },
      {
        text: 'To deselect your chosen answer click on the <span class="bold">Clear response</span> button'
      },
      {
        text: 'To change your chosen answer, click on the button of another option'
      },
      {
        text: 'To save your answer, you must click on the <span class="bold">Save & next</span> button'
      },
      {
        text: 'To mark the question for review, click on the <span class="bold">Mark for review</span> button.'
      }
    ]
  },
  {
    text: 'To change your answer to a question that has already been answered, first select that question for answering and then follow the procedure for answering that type of question.'
  }
];

export const SECTION_NAV_INSTRUCTIONS = [
  {
    text: 'Sections in this question paper are displayed on the top bar of the screen. Questions in a section can be viewed by clicking on the section name. The section you are currently viewing is highlighted.'
  },
  {
    text: 'After clicking the <span class="bold">Save & next</span> button on the last question for a section, you will automatically be taken to the first question of the next section.'
  },
  {
    text: 'You can shuffle between sections and questions anything during the examination as per your convenience only during the time stipulated.'
  },
  {
    text: 'The candidate can view the corresponding section summary as part of the legend that appears in every section above the question palette.'
  }
];
